import { useMemo } from "react";
import { useRemoteConfigString } from "@/context/RemoteConfigContext";
import { chatApiUrlFor, type ChatBackend } from "@/lib/chatBackend";

/**
 * Where this business's Intelligence chat posts: `apiChat`, or agent-brain when the
 * business is flagged in through Remote Config (docs/ai-platform/09, 09f). Re-reads
 * when Remote Config activates, like every other flag hook.
 */
export function useChatApiUrl(businessId: string | null | undefined): {
  url: string;
  backend: ChatBackend;
} {
  const flag = useRemoteConfigString("intelligence_chat_brain_businesses");
  return useMemo(() => chatApiUrlFor(businessId, flag), [businessId, flag]);
}
